module.exports = __webpack_public_path__ + "img/duplicate-icon.1f943907.svg";